<template>
    <v-dialog v-model="show" max-width="600px">
        <v-card>
            <v-card-title class="headline">이메일 수신자 목록</v-card-title>
            <v-card-text>
                <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="mailHistoryTable"
                        :single-select="singleSelect"
                        :server-items-length="totalItems"
                        item-key="name"
                        :options.sync="dataTableOptions"
                        class="elevation-1"
                        hide-default-footer

                >
                    <template v-slot:item.mailReceived="{ item }">
                        {{item.recipient ? "수신": "미수신"}}
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions class="align-center justify-center">
                <v-btn color="#fafafa" class="vIconResize" @click.stop="show = false">
                    <v-icon left>mdi mdi-close</v-icon>
                    닫기
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import mailApi from "@/api/MailApi";

    export default {
        name: "MailDialog",
        props: ['visible', 'from'],
        data: () => ({
            dialog: false,
            selected: [],
            headers: [
                { text: '이름', value: 'fullName', sortable: false, align: 'center' },
                { text: '연락처', value: 'mobileNo', sortable: false, align: 'center' },
                { text: '수신 여부', value: 'mailReceived', sortable: false, align: 'center' },
            ],
            mailHistoryTable: [
                {
                },
            ],
            totalItems: 0,
            dataTableOptions :{
                page:1,
                itemsPerPage:10
            },
            singleSelect: false,
        }),
        computed: {
            show: {
                get() {
                    this.selectMailHistory();
                    return this.visible
                },
                set(value) {
                    if (!value) {
                        this.$emit('close')
                    }
                },
            },
        },
        methods: {
            confirm() {
                this.show = false;
            },
            selectMailHistory(){

                let from = this.from;
                if(from == null){
                    return;

                }
                mailApi.history(this.from).then(data =>{
                    this.mailHistoryTable = data;
                    this.totalItems = data.totalElements;
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/style/layout/variables';
    .headline {
        @include h2-title;
        margin: 0;
        background: #1867c0;
        color: #fff;
    }

</style>
